export default __webpack_public_path__ + "74c57d433f865b272492761ee580bbb5.png";